import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { Settings } from 'lucide-react';

export default function ParametriChiusure() {
  return (
    <Box sx={{ p: 3 }}>
      <Card
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1 }}>
          <Settings size={20} />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            parametri_chiusure
          </Typography>
        </Box>
        <Typography color="text.secondary">
          Pagina predisposta. In attesa delle specifiche funzionali.
        </Typography>
      </Card>
    </Box>
  );
}
